import React from 'react';
import { Gift } from 'lucide-react';

interface ReferralBoxProps {
  onClick: () => void;
}

const ReferralBox: React.FC<ReferralBoxProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="bg-white rounded-2xl p-6 shadow-sm border-2 border-gray-200 hover:border-gray-900 transition-colors w-full text-left"
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h2 className="text-lg font-bold text-gray-900 mb-1">Share this</h2>
          <p className="text-sm text-gray-600">Get up to 10 FitCoins</p>
        </div>
        <div className="flex-shrink-0">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center">
            <Gift className="text-purple-600" size={24} />
          </div>
        </div>
      </div>
    </button>
  );
};

export default ReferralBox;
